import { requestV2, requestV2Internal } from './request'
import type { EVENTS } from '@types'
import { findRegionByLocale } from '@/common/region-locale'

export async function getTopEventsList(locale?: string): Promise<EVENTS.EventList> {
  const params: any = { type: 'top' }

  // 如果传递了locale参数，使用对应的region覆盖默认的region
  if (locale) {
    params.region = findRegionByLocale(locale)
  }

  const res = await requestV2('/event/list', params)
  return res
}

getTopEventsList.swrkey = (locale: string) => `/${locale}/api/front/v2/event/list/top`

// 事件页 首页板块list {{host}}/api/front/v2/event/list
export async function getEventsList(
  pagination: { offset: number; limit: number },
  status: string
): Promise<EVENTS.EventList> {
  const res = await requestV2('/event/list', { ...pagination, status })

  return res
}
getEventsList.swrkey = (locale: string, articleType: string) => `/${locale}/api/front/v2/event/list/${articleType}`

// 获取事件详情
export async function getEventDetails(data: { docId: string; region: string }): Promise<EVENTS.EventDetails> {
  const res = await requestV2Internal('/event/info', data)

  return res
}
